<template>
  <div style="border-radius: 16px">
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>机构运营</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-form :inline="true" :model="formContent" label-width="120px" class="searchForm" label-position="left">
      <el-form-item label="机构应用名称">
        <el-input v-model.trim="formContent.name" v-if="addInstitutionStatus"></el-input>
        <div style="font-size: 12px" v-if="addInstitutionStatus">*名称会显示在硬件设备主菜单</div>
        <p v-if="!addInstitutionStatus">{{ formContent.name }}</p>
      </el-form-item>

      <br />
      <el-form-item label="应用icon">
        <el-row type="flex" class="row-bg" style="width: 700px" v-if="addInstitutionStatus">
          <el-col :span="5">
            <el-upload class="avatar-uploader" ref="uploadxls" action="/aries-api/resource/upload" :show-file-list="false"
              :before-upload="onBeforeUpload" :on-success="onSuccessUpload" :data="uploadData"
              accept="image/png,image/gif,image/jpg,image/jpeg">
              <i v-show="!formContent.imgUrl" class="el-icon-upload avatar-uploader-icon"></i>
              <img :src="formContent.imgUrl" style="width:100%;height:100%;" alt="" />
              <div style="font-size: 12px" slot="tip" class="el-upload__text upload__tip">
                <!-- *上传icon尺寸为92*92 -->
              </div>
            </el-upload>
          </el-col>
          <el-col :span="4" v-if="formContent.imgUrl != ''">
            <el-button size="small" type="danger" @click="delFrontCover" icon="el-icon-delete">删除</el-button>
          </el-col>
        </el-row>
        <img :src="formContent.imgUrl" alt="" v-if="!addInstitutionStatus">
      </el-form-item>
      <br />
      <el-form-item>
        <el-button type="primary" @click="addInstitution" icon="arrow-up" style="margin-left: 30px"
          v-if="ids && !addInstitutionStatus">编辑</el-button>
        <el-button type="primary" @click="commitInstitution" icon="arrow-up" style="margin-left: 30px"
          v-if="addInstitutionStatus">提交</el-button>
        <el-button type="warning" @click="delInstitutionStatus" icon="arrow-up" style="margin-left: 30px"
          v-if="ids && addInstitutionStatus">取消</el-button>
        <el-button type="danger" @click="delInstitution" icon="arrow-up" style="margin-left: 30px"
          v-if="ids && !addInstitutionStatus">删除当前机构</el-button>
      </el-form-item>
    </el-form>
    <el-button type="primary" v-if="!ids && !addInstitutionStatus" @click="addInstitution">创建机构</el-button>
    <div class="operBtn">
      <el-button type="primary" @click="creatInvitation" icon="arrow-up">创建邀请码</el-button>
    </div>
    <el-dialog :title="paltaId ? '编辑运营内容' : '分享运营内容'" :visible.sync="dialogVisible" width="60%" center v-if="step == 0">
      <el-form :model="form" label-width="125px">
        <el-form-item label="*邀请码类型">
          <el-select v-model="form.valueTo" placeholder="请选择" :disabled="paltaId ? true : false">
            <el-option v-for="item in InvitationCode" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="form.valueTo == 1 ? '人数' : '*SN数量'">
          <el-select v-model="form.peopleNumTo" placeholder="请选择" v-if="form.valueTo == 1">
            <el-option v-for="item in peopleNum" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="form.peopleNumToSelf" placeholder="请选择" v-if="form.valueTo != 1">
            <el-option v-for="item in peopleNumSelf" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="form.valueTo == 1 ? '使用时限' : '*兑换时限'">
          <el-date-picker v-model="form.startTime" type="date" format="yyyy-MM-dd"
            style="width: 180px; font-size: 10px"></el-date-picker>
          至
          <el-date-picker v-model="form.endTime" type="date" format="yyyy-MM-dd"
            style="width: 180px; font-size: 10px"></el-date-picker>
        </el-form-item>
        <el-form-item label="授权设备">
          <template>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
              @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="deviceAppidList" @change="handledeviceAppidListChange">
              <el-checkbox v-for="item in allAppidList" :label="item.appId" :key="item.appId">{{ item.name
              }}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="3" style="width: 50%"></el-input>
        </el-form-item>
      </el-form>
      <el-button @click="createdInvitaCode" v-if="paltaId == ''"
        style="background-color: #009e7d; color: #ffffff; margin-bottom: 20px">
        {{ form.valueTo == 1 ? "创建邀请码" : "创建专享码" }}
      </el-button>
      <el-button @click="createdInvitaCode" v-if="paltaId != ''"
        style="background-color: #009e7d; color: #ffffff; margin-bottom: 20px">
        {{ form.valueTo == 1 ? "编辑邀请码" : "编辑专享码" }}
      </el-button>
      <span slot="footer" class="dialog-footer" style="float: right; margin-top: -40px">
        <el-button @click="cancelInsitution">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="创建成功" :visible.sync="dialogVisible" width="60%" center v-if="step == 1">
      <el-form :model="formNext" label-width="80px" v-if="typeValueTo == 1">
        <el-form-item label="邀请码">
          <el-input v-model="formNext.Invitation" style="width: 220px" :disabled="true">
          </el-input>
        </el-form-item>
      </el-form>
      <p v-if="typeValueTo != 1">创建了{{ numPeopleTo }}个专项码</p>
      <el-button v-if="typeValueTo == 1" @click="copyInvitation" style="
          background-color: #009e7d;
          color: #ffffff;
          margin-bottom: 20px;
          margin-top: 20px;
        ">
        复制邀请码
      </el-button>
      <el-button v-if="typeValueTo != 1" @click="checkInvitation" style="
          background-color: #009e7d;
          color: #ffffff;
          margin-bottom: 20px;
          margin-top: 20px;
        ">
        查看
      </el-button>
      <span slot="footer" class="dialog-footer" style="float: right; margin-top: -40px">
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <Card style="margin-top: 60px">
      <div class="panel-box">
        <h3 class="panel-title">分享记录</h3>
        <div class="tableToList">
          <el-table ref="multipleTable" :header-cell-style="rowClass" :data="queryData" style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column prop="createdAt" label="生成时间" align="center" min-width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.createdAt | formatDate2 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="邀请码类型" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">邀请码</span>
                <span v-if="scope.row.type == 2">专享码</span>
              </template></el-table-column>

            <el-table-column prop="lable" label="使用期限" align="center" min-width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.startTime | formatDate3 }} ——
                  {{ scope.row.endTime | formatDate3 }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="lable" label="授权设备" align="center" min-width="150">
              <template slot-scope="scope">
                <span>{{ fetchNameByAppid(scope.row.authAppIds) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="usedCnt" label="领取人数" align="center" min-width="100">
              <template slot-scope="scope">
                <span>{{ scope.row | getUsedCnt }}</span>
              </template></el-table-column>
            <el-table-column prop="categoryId" label="操作" align="center" width="180">
              <template slot-scope="scope">
                <el-tooltip content="编辑" placement="top">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="handleEdit(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="详情" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-document" style="background-color: #009e7d"
                    @click="handleInvitationDetail(scope.row)"></el-button>
                </el-tooltip> </template></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination-box" style="padding: 30px 0px 30px 0px !important">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page" :page-sizes="[20, 50, 100]" :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pageTotal"></el-pagination>
      </div>
    </Card>
  </div>
</template>

<script>
const checkFormat = (file, format) => {
  const type = file.type.split("/")[1];
  let temp = [];
  let isRight = false;
  if (format === "video") {
    temp = ["mp4", "avi", "wmv"];
  } else if (format === "picture") {
    temp = ["png", "jpg", "jpeg"];
  } else if (format === "audio") {
    temp = ["mp3", "mpeg"];
  }
  temp.find((item) => {
    if (item === type) {
      isRight = true;
    }
  });
  if (!isRight) {
    Message.error("上传文件只能是" + format);
  }
  return isRight;
};
import { ApiMessage, formatDate } from "@/utils/util";
import moment from "moment";
export default {
  name: "institution",

  data() {
    return {
      paltaId: "",
      formPlan: {},
      queryData: [],
      formNext: {
        Invitation: "",
      },
      loading: false,
      formContent: {
        name: "",
        imgUrl: "",
      },
      uploadData: { isOnlyMP3: "false", pdfToPng: "false" },
      dialogVisible: false,
      ids: "", //当前同步机构id
      InvitationCode: [
        { value: 1, label: "邀请码" },
        { value: 2, label: "专享码" },
      ],
      peopleNum: [
        { value: 0, label: "不限" },
        { value: 500, label: "500人" },
        { value: 200, label: "200人" },
        { value: 100, label: "100人" },
      ],
      peopleNumSelf: [
        { value: 500, label: "500人" },
        { value: 200, label: "200人" },
        { value: 100, label: "100人" },
      ],

      form: {
        valueTo: "", //邀请码类型,
        peopleNumTo: 0, //人数限制
        peopleNumToSelf: 100,
        startTime: "",
        endTime: "",
        remark: "",
      },
      step: 0, //创建成功翻页状态
      numPeopleTo: "",
      rowId: "",
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      pageTotal: 0,
      deviceAppidList: [],
      allAppidList: [],
      isIndeterminate: true,
      checkAll: true,
      addInstitutionStatus: false,
    };
  },
  async created() {
    console.log(this.$API.APPID, "APPID");
    await this.saveInstitution();
    this.fetchDeviceAppid()
    console.log(this.ids, "idsids");
    if (this.ids != "") {
      this.saveinviteCodeList();
    }
  },
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd hh:mm:ss");
    },
    formatDate3(d) {
      return formatDate(d, "yyyy-MM-dd");
    },
    getUsedCnt(row) {
      if (row.personLimit == 0) {
        return `${row.usedCnt}/${"不限"}`;
      } else {
        return `${row.usedCnt}/${row.personLimit}`;
      }
    },
  },
  methods: {
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    onBeforeUpload(file) {
      // console.log(file);
      // this.formContent.imgUrl = file.url;

      if (!checkFormat(file, "picture")) {
        return false;
      }
      // return this.checkImageWH(file, 92, 92);
      return this.checkImageWH(file);
    },
    onSuccessUpload(response, file, fileList) {
      this.formContent.imgUrl = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    uploadInstitutionFile() { },
    delFrontCover() {
      this.formContent.imgUrl = "";
    },

    detailBeforeUpload(file) { },
    // 显示图片宽高
    checkImageWH(file) {
      // let self = this;
      return new Promise(function (resolve, reject) {
        let filereader = new FileReader();
        filereader.onload = (e) => {
          let src = e.target.result;
          const image = new Image();
          image.onload = function () {
            // if (width && this.width != width) {
            //   alert(
            //     "请上传宽为" + width + "px的图片和高为" + height + "px的图片"
            //   );
            //   reject();
            // } else if (height && this.height != height) {
            //   alert(
            //     "请上传高为" + height + "px的图片和宽为" + width + "px的图片"
            //   );
            //   reject();
            // } else {
              resolve();
            // }
          };

          image.onerror = reject;
          image.src = src;
        };
        filereader.readAsDataURL(file);
      });
    },
    fetchNameByAppid(authAppIds) {
      const matchedNames = this.allAppidList.filter(item => authAppIds.includes(item.appId)).map(item => item.name);
      if (matchedNames.length == this.allAppidList.length || authAppIds.length == 0) {
        return "全部设备"
      } else {
        return matchedNames.join('、');
      }
    },
    fetchDeviceAppid() {
      let params = {
        appId: this.$API.APPID,
      }
      this.$axios
        .post("/edu/eduAdmin/hxd/appid_list", params)
        .then((response) => {
          if (response.data.rc == "0") {
            this.allAppidList = response.data.data.list;
            this.deviceAppidList = this.allAppidList.map(item => item.appId)
            console.log(this.allAppidList, "this.allAppidList");
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    handleCheckAllChange(val) {
      let _data = this.allAppidList.map(item => item.appId)
      this.deviceAppidList = val ? _data : [];
      this.isIndeterminate = false;
    },
    handledeviceAppidListChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.allAppidList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allAppidList.length;
    },
    addInstitution() {
      this.addInstitutionStatus = true
    },
    delInstitutionStatus() {
      this.addInstitutionStatus = false
      this.saveInstitution()
    },
    creatInvitation() {
      console.log(this.ids);
      if (this.ids == "") {
        alert("请核实同步机构");
        return;
      }
      this.dialogVisible = true;
      this.form.valueTo = 1;
      this.form.peopleNumTo = 0;
      this.form.startTime = ""
      this.form.endTime = ""
      this.form.remark=""
      this.step = 0;
      this.paltaId = "";
      this.isIndeterminate = false;
      this.checkAll = true;
      this.deviceAppidList = this.allAppidList.map(item => item.appId)
    },
    // 创建邀请码
    createdInvitaCode() {
      if (this.form.startTime == null || this.form.endTime == null) {
        alert("时限开始时间或结束时间不能为空");
        return;
      }
      let getStartTime = moment(this.form.startTime).unix();
      let getEndTime = moment(this.form.endTime).unix() + (24 * 60 * 60 - 1);
      let nowTime = moment(
        formatDate(new Date().valueOf(), "yyyy-MM-dd")
      ).unix();
      if (this.paltaId !== "") {
        let params = {
          appId: this.$API.APPID,
          inviteId: String(this.paltaId),
          type: this.form.valueTo,
          remark: this.form.remark,
        };
        if (this.deviceAppidList.length == 0) {
          alert("请选择授权设备");
          return;
        } else {
          params.authAppIds = this.deviceAppidList.length == this.allAppidList.length ? [] : this.deviceAppidList
        }
        if (this.form.valueTo == 1) {
          // 邀请码
          if (
            this.form.peopleNumTo &&
            this.form.peopleNumTo < this.formPlan.getCnt
          ) {
            alert("邀请码数量不能小于已生成的数量");
            return;
          }
          params.personLimit = this.form.peopleNumTo;
        } else if (this.form.valueTo == 2) {
          // 专享码
          if (this.form.peopleNumToSelf < this.formPlan.getCnt) {
            alert("专享码SN数量不能小于修改前的SN数量");
            return;
          }
          params.personLimit = this.form.peopleNumToSelf;
        }
        if (getStartTime > getEndTime) {
          alert("使用期限开始日期不能大于结束日期");
          return;
        }
        if (nowTime > getEndTime) {
          alert("使用期限结束日期不能小于当前日期");
          return;
        }
        params.startTime = getStartTime;
        params.endTime = getEndTime;
        this.$axios
          .post("/edu/eduAdmin/hxd/invite_code_save", params)
          .then((response) => {
            if (response.data.rc == "0") {
              this.$message.success("编辑成功");
              this.dialogVisible = false;
              this.paltaId = "";
              this.saveinviteCodeList();
            } else {
              alert(response.data.err);
            }
          });
      } else {
        if (this.form.startTime == "" || this.form.endTime == "") {
          alert("起始时间或结束时间不能为空");
          return;
        } else if (this.form.startTime > this.form.endTime) {
          alert("起始时间不能大于结束时间");
          return;
        }

        if (getStartTime == getEndTime) {
          alert("起始时间于结束时间不能为同一天");
          return;
        }
        // console.log(this.form, getStartTime, getEndTime);
        let params = {
          appId: this.$API.APPID,
          targetId: String(this.ids),
          targetCategory: 1,
          type: this.form.valueTo,
          startTime: getStartTime,
          endTime: getEndTime,
          remark: this.form.remark,
        };
        if (this.deviceAppidList.length == 0) {
          alert("请选择授权设备");
          return;
        } else {
          params.authAppIds = this.deviceAppidList.length == this.allAppidList.length ? [] : this.deviceAppidList
        }
        if (this.form.valueTo == 1) {
          params.personLimit = this.form.peopleNumTo;
        } else {
          params.personLimit = this.form.peopleNumToSelf;
        }
        this.$axios
          .post("/edu/eduAdmin/hxd/invite_code_save", params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              this.step = 1;
              this.rowId = response.data.data.inviteId;

              if (response.data.data.inviteCode) {
                this.typeValueTo = 1;
                this.formNext.Invitation = response.data.data.inviteCode;
                this.saveinviteCodeList();
              } else {
                this.typeValueTo = 2;
                this.saveinviteCodeList().then(() => {
                  let row = this.queryData.find((item) => {
                    return item.id == this.rowId;
                  });
                  this.numPeopleTo = row.personLimit;
                });
              }
              this.form = {
                valueTo: "", //邀请码类型,
                peopleNumTo: 0, //人数限制
                peopleNumToSelf: 100,
                startTime: "",
                endTime: "",
                remark: "",
              };
            } else {
              alert(response.data.err);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
          });
      }
    },

    handleEdit(row) {
      console.log(row);
      this.formPlan = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
      this.step = 0;
      console.log(row);
      this.form.valueTo = row.type;
      this.paltaId = row.id;
      this.$set(this.form, "remark", row.remark);
      this.$set(this.form, "peopleNumTo", row.personLimit);
      this.$set(this.form, "peopleNumToSelf", row.personLimit);
      this.$set(
        this.form,
        "startTime",
        formatDate(row.startTime, "yyyy-MM-dd")
      );
      this.$set(this.form, "endTime", formatDate(row.endTime, "yyyy-MM-dd"));
      if (row && row.authAppIds) {
        this.deviceAppidList = JSON.parse(JSON.stringify(row.authAppIds));
      } else {
        this.deviceAppidList = []
      }
      if (this.deviceAppidList.length == this.allAppidList.length || this.deviceAppidList.length == 0) {
        this.deviceAppidList = this.allAppidList.map(item => item.appId)
        this.isIndeterminate = false
        this.checkAll = true
      } else {
        this.isIndeterminate = true
        this.checkAll = false
      }
    },
    // 获取邀请码列表
    saveinviteCodeList() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          targetId: String(this.ids),
        };
        params.pageSize = this.queryParams.pageSize;
        params.page = this.queryParams.page;
        this.$axios
          .post("/edu/eduAdmin/hxd/invite_code_list", params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              this.queryData = response.data.data.list;
              this.pageTotal = response.data.data.pager.total;
              resolve();
            } else {
              alert(response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
      // let params = {
      //   appId: this.$API.APPID,
      //   targetId: String(this.ids),
      // };
      // this.$axios
      //   .post("/edu/eduAdmin/hxd/invite_code_list", params)
      //   .then((response) => {
      //     console.log(response);
      //     if (response.data.rc == "0") {
      //       this.queryData = response.data.data;
      //     } else {
      //       alert(response.data.err);
      //     }
      //   })
      //   .catch((error) => {
      //     ApiMessage(this, error.toString(), "error");
      //   });
    },
    // 当前邀请码详情
    handleInvitationDetail(row) {
      const routeData = this.$router.resolve({
        path: "/invitationDetail",
        query: row,
      });
      window.open(routeData.href, "_blank");
    },
    handleSelectionChange() { },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.saveinviteCodeList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.saveinviteCodeList();
    },
    cancelInsitution() {
      this.dialogVisible = false;
    },

    // 删除同步机构
    delInstitution() {
      console.log("delInstitution");
      let params;
      if (this.ids) {
        params = {
          id: new String(this.ids),
          appId: this.$API.APPID,
        };
      } else {
        alert("请核实同步机构是否存在");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除?",
        content: "<ul><li>请确认是否删除当前机构</li></ul>",
        onOk: () => {
          this.$axios
            .post("/edu/eduAdmin/institution/delete", params)
            .then((response) => {
              if (response.data.rc == "0") {
                this.$Message.error("删除成功!");
                this.formContent = {
                  name: "",
                  imgUrl: "",
                };
                this.formNext.Invitation = "";
                this.ids = "";
                this.queryData = [];
                this.addInstitutionStatus = false
              } else {
                alert(response.data.err);
              }
            })
            .catch((error) => {
              ApiMessage(this, error.toString(), "error");
            });
        },
      });
    },
    // 新增/编辑  同步机构
    commitInstitution() {
      let params;
      if (this.ids) {
        params = {
          id: new String(this.ids),
          appId: this.$API.APPID,
        };
      } else {
        params = {
          id: "0",
          appId: this.$API.APPID,
        };
      }
      if (this.formContent != null) {
        if (this.formContent.name != "") {
          params.appName = this.formContent.name;
        } else {
          alert("机构应用名称不能为空");
          return;
        }
        if (this.formContent.imgUrl != "") {
          params.icon = this.formContent.imgUrl;
        } else {
          alert("机构应用icon不能为空");
          return;
        }
      }

      this.$axios
        .post("/edu/eduAdmin/institution/save", params)
        .then((response) => {
          if (response.data.rc == "0") {
            this.$Message.success("机构编辑成功!");
            this.saveInstitution();
          } else {
            alert(response.data.err);
          }
          this.addInstitutionStatus = false
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
      console.log("commitInstitution");
    },
    // creatInstitution() {
    //   let params = {
    //     appId: this.$API.APPID,
    //   };
    // if (this.ids != "") {
    //   params.id = new String(this.ids);
    // } else {
    //   alert("请核实同步机构");
    //   return;
    // }
    //   this.$axios
    //     .post("/edu/eduAdmin/institution/save_invite_code", params)
    //     .then((response) => {
    //       console.log(response);
    //       this.formNext.Invitation = response.data.data.inviteCode;

    //       this.dialogVisible = true;
    //     })
    //     .catch((error) => {
    //       ApiMessage(this, error.toString(), "error");
    //     });
    //   console.log("downInstitution");
    // },

    // 获取同步机构
    saveInstitution() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
        };
        this.$axios
          .post("/edu/eduAdmin/institution/list", params)
          .then((response) => {
            console.log(response, "eee");

            if (response.data.rc == "0") {
              let _data = response.data.data;
              this.formContent.name = _data.appName;
              this.formContent.imgUrl = _data.icon;
              this.ids = _data.id;
              console.log(_data, "saveInstitution====");
              resolve();
            } else {
              this.addInstitutionStatus = false
              resolve();
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    // 分享

    // 复制邀请码
    copyInvitation() {
      console.log("copyInvitation---copyInvitation");
      this.$copyText(this.formNext.Invitation).then(
        function (e) {
          // debugger;
          alert("复制成功");
        },
        function (e) {
          alert("Can not copy");
        }
      );
    },
    lookInvitation() {
      console.log(this.formNext.Invitation);
      this.dialogVisible = true;
    },
    async checkInvitation() {
      await this.saveinviteCodeList();
      console.log(
        this.queryData,
        "rowDatarowDatarowDatarowDatarowDatarowData",
        this.rowId
      );
      let row = this.queryData.find((item) => {
        return item.id == this.rowId;
      });
      const routeData = this.$router.resolve({
        path: "/invitationDetail",
        query: row,
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style  scoped>
.tableList {
  margin-top: 50px;
  border-radius: 10px;
  background: #fff;
  padding: 10px;
}

.tableList>#Table {
  width: 98%;
  margin: -10px auto;
}

.tableList>.bottomOperBtn {
  padding: 10px 20px;
  float: left;
}

.panel-title {
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  padding-left: 10px;
  line-height: 20px;
  border-left: 4px solid #009e7d;
}

.panel-content {
  margin-bottom: 30px;
}

.avatar-uploader {
  display: flex;
  flex-direction: column;
}

.avatar-uploader>>>.el-upload {
  width: 92px;
  height: 92px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader>>>.el-upload:hover {
  border-color: #409eff;
}

/* .avatar-uploader >>> .el-upload .el-upload--text {
} */
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 92px;
  height: 92px;
  line-height: 92px;
  text-align: center;
}

.avatar {
  width: 92px;
  height: 92px;
  display: block;
}

.el-button--primary:hover,
.el-button--primary {
  color: #fff;
  background-color: #009e7d !important;
  border-color: #009e7d !important;
}

.el-button--primary.is-disabled {
  color: #fff;
  background-color: #a9cabf !important;
  border-color: #a9cabf !important;
}

.operBtn button {
  float: right;
}

.pagination-box {
  padding: 74px 10px 30px 10px !important;
}
</style>





// WEBPACK FOOTER //
// institution.vue?6aed38d3